import styled from 'styled-components';
const ResultListStyled = styled.div`
  flex-grow: 1;

  .handle_btn {
    padding: 0 24px;
    justify-content: center;
    display: flex;

    .no-drop {
      cursor: not-allowed;
    }

    > div {
      margin-right: 15px;
    }

    .icon {
      /* fill: '#BDBDBD'; */
    }

    .preview {
      cursor: pointer;
    }
    .canClick {
      width: 18px;
      height: 18px;
      vertical-align: middle;
      /* fill: '#1B60AD'; */
      cursor: pointer;
    }
  }
  .hover {
    cursor: pointer;
    position: relative;
    display: block;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    transform: scale(1, 1);
    transition: all 0.3s;
  }
  .hover:hover {
    transform: scale(1.1, 1.1);
    transition: all 0.3s;
  }
  .modal-header-close-icon {
    width: 20px;
    height: 20px;
    color: #212121;
  }
`;
export default ResultListStyled;
